import styled from "styled-components";
import { Button } from "primereact/button";
import { theme } from "styles/theme";

// Containers
export const PageContainer = styled.div`
  padding: 1rem 0;
  height: 100%;
`;

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
`;

export const PageTitle = styled.h1`
  color: ${theme.colors.textPrimary};
  margin: 0;
`;

export const ContentContainer = styled.div`
  background-color: ${theme.colors.surface};
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.borderRadius.medium};
  box-shadow: ${theme.shadows.small};
  padding: 1.5rem;
  color: ${theme.colors.textPrimary};
`;

export const DetailsTabView = styled.div`
  .p-tabview-nav {
    background: ${theme.colors.bgLight};
    border-bottom: 1px solid ${theme.colors.border};
    margin: 0 0 0.5rem;
  }

  .p-tabview-panels {
    background: ${theme.colors.surface};
    color: ${theme.colors.textPrimary};
    padding-top: 1rem;
  }

  .p-tabview-nav li .p-tabview-nav-link {
    color: ${theme.colors.textSecondary};
  }

  .p-tabview-nav li.p-highlight .p-tabview-nav-link {
    color: ${theme.colors.textPrimary};
    background: ${theme.colors.surface};
    box-shadow: inset 0 -2px 0 var(--davey-section-accent);
  }
`;

// Dealer info section
export const DealerInfoSection = styled.div`
  margin-bottom: 2rem;
`;

export const DealerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
`;

export const DealerName = styled.h2`
  color: ${theme.colors.textPrimary};
  margin: 0;
  font-weight: ${theme.fontWeights.medium};
`;

export const DealerInfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
`;

export const InfoCard = styled.div`
  padding: 1rem;
  border-radius: ${theme.borderRadius.small};
  background-color: ${theme.colors.bgLight};
  border-left: 4px solid var(--davey-section-accent);
  transition: transform 0.2s, box-shadow 0.2s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: ${theme.shadows.medium};
  }
`;

export const InfoLabel = styled.div`
  color: ${theme.colors.textSecondary};
  font-size: ${theme.fontSizes.small};
  margin-bottom: 0.5rem;
`;

export const InfoValue = styled.div`
  color: ${theme.colors.textPrimary};
  font-weight: ${theme.fontWeights.medium};
`;

// Status badge
export const StatusBadge = styled.span<{ status: string }>`
  background-color: ${({ status }) =>
    status === "active" ? theme.colors.statusActive : theme.colors.lightGrey};
  color: ${({ status }) =>
    status === "active"
      ? theme.colors.statusActiveText
      : theme.colors.darkGrey};
  padding: 0.25rem 0.75rem;
  border-radius: 100px;
  font-size: 0.85rem;
  font-weight: ${theme.fontWeights.medium};
`;

// Section elements
export const SectionTitle = styled.h2`
  color: ${theme.colors.textPrimary};
  font-size: ${theme.fontSizes.large};
  margin-bottom: 1rem;
`;

// Navigation and buttons
export const BackButton = styled(Button)`
  background-color: transparent;
  border: 1px solid ${theme.colors.tertiary};
  color: ${theme.colors.textPrimary};

  &:hover {
    background-color: ${theme.colors.tertiary};
    color: ${theme.colors.onTertiary};
  }
`;
